<ng-container *transloco="let t; read: 'configuration'">
<div class="p-5">
  <div class="flex justify-between">
    <drdp-title [title]="label"></drdp-title>
    @if (id.value) {
      <span>
        <drdp-btn *drdpCheckPermission="Permission.IntegrationManagement" color="outline"
        (click)="generateAPIKey()">{{ t('integrations.generateApiKey') }}</drdp-btn>
      </span>
    }
  </div>

  <drdp-container [additionClasses]="'min-h-[22rem]'">
    <form class="grid grid-cols-2 gap-x-8 gap-x-10 pt-5" [formGroup]="vendorForm">

      <div class="col-span-1 items-center w-[100%]">
        <label class="font-normal required" for="name">{{ t('integrations.vendorName') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput [placeholder]="t('integrations.vendorName')" autocomplete="off" id="vendorName" type="text"
            formControlName="name" maxlength="50" required>
        </mat-form-field>
      </div>

      <div class="col-span-1 items-center w-[100%]">
        <div class="grid grid-cols-2 gap-x-4 gap-x-10">

          <div class="col-span-1 items-center w-[100%]">
            <label class="font-normal" for="name">{{ t('integrations.vendorId') }}</label>
            @if (id.value) {
              <p>{{id.value}}</p>
            }
          </div>

          <div class="col-span-1 items-center w-[100%]">
            <label class="font-normal" for="name">{{ t('integrations.visibility') }}</label>
            <mat-checkbox formControlName="isVisible" color="primary">
            </mat-checkbox>
          </div>

        </div>
      </div>

      <div class="col-span-1 items-center w-[100%]">
        <label class="font-normal required" for="name">{{ t('integrations.contactEmail') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput [placeholder]="t('integrations.contactEmailPlaceholder')" autocomplete="off" id="email" type="text"
            formControlName="emailName" maxlength="100">
        </mat-form-field>
      </div>

      <div class="col-span-1 items-center w-[100%]">
        <label class="font-normal" for="name">{{ t('integrations.contactPhone') }}</label>
        <mat-form-field class="bg-white" appearance="fill">
          <input matInput [placeholder]="t('integrations.contactPhonePlaceholder')" autocomplete="off" id="phone" type="text"
            mask="(000) 000-0000" formControlName="phoneNumber" maxlength="">
        </mat-form-field>
      </div>

      <div class="col-span-1 items-center w-[100%]">
        <label class="font-normal" for="permissions">{{ t('integrations.permissions') }}</label>
        <div class="grid grid-cols-2 gap-x-4 gap-x-10">

          <div class="col-span-1 items-center w-[100%]">
            <mat-checkbox formControlName="permissions_hasSingleScore" color="primary">
              {{ t('integrations.singleScore') }}
            </mat-checkbox>
          </div>
          <div class="col-span-1 items-center w-[100%]">
            <mat-checkbox formControlName="permissions_hasAgencyExtract" color="primary">
              {{ t('integrations.agencyExtract') }}
            </mat-checkbox>
          </div>

        </div>
      </div>
    </form>
    <div class=" flex grow"></div>
    <div mat-dialog-actions class="flex justify-end ">
      <drdp-btn type="button" color="cancel" class="mr-2" [routerLink]="'/config/integrations'"
      mat-button>{{ t('common.cancel') }}</drdp-btn>
      <drdp-btn type="submit" [disabled]="vendorForm.invalid" (click)="submit()">{{ t('integrations.saveAndExit') }}</drdp-btn>
    </div>
  </drdp-container>
</div>
</ng-container>
